import { Component, EventEmitter, Output } from '@angular/core';
import {SlideshowService} from '../../slideshow.service';
import { Utils } from '../../../utils';

@Component({
    selector: 'content-quiz',
    templateUrl: 'content-quiz.component.html'
})
export class PreviewContentQuizComponent {
    intro;
    questions = [];
    outro;
    @Output('loaded') loaded = new EventEmitter();

    constructor(private slideshow: SlideshowService, public utils: Utils) {
        const slides = this.slideshow.slides;
        this.intro = slides[0];
        const lastIndex = slides.length - 1;
        this.outro = slides[lastIndex];
        this.questions = slides.filter(item => !item.intro && !item.outro);
    }
    ngAfterViewInit() {
        this.loaded.emit(true);
    }
}